import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import 'pretendard/dist/web/static/pretendard.css';

const GlobalStyles = createGlobalStyle`
  ${reset}
  * {
    box-sizing: border-box;
    font-family: 'pretendard', sans-serif;
    scrollbar-width: thin;
  }
  html, body, #root {
    width: 100%;
    height: 100%;
    font-family: 'pretendard', sans-serif;
  }
  a {
    text-decoration: none;
    color: inherit;
    display: block;
  }
`;

export default GlobalStyles;
